/* ═══════════════════════════════════════════════════
   NEWJAISA — STARTUPS & PRIVATE ENTERPRISE PAGE
   File: assets/component-startups.js
   Namespace: EntPage · No globals · No jQuery
   Note: No Final CTA → no scrollToCTA
═══════════════════════════════════════════════════ */

'use strict';

var EntPage = (function () {

  function $(id)   { return document.getElementById(id); }
  function $$(sel) { return Array.from(document.querySelectorAll(sel)); }

  /* ── STAGE CONFIG ───────────────────────── */
  var STAGE_CONFIG = {
    bootstrap: { disc: 0,    leaseRate: 0.095 },
    seed:      { disc: 0.05, leaseRate: 0.08  },
    seriesa:   { disc: 0.08, leaseRate: 0.052 },
    seriesb:   { disc: 0.12, leaseRate: 0.038 },
    smb:       { disc: 0.08, leaseRate: 0.06  }
  };

  var activeStage = 'seriesa';

  /* ── FORMAT INR ─────────────────────────── */
  function fmtINR(n) {
    if (n >= 10000000) return '₹' + (n / 10000000).toFixed(1) + ' Cr';
    if (n >= 100000)   return '₹' + (n / 100000).toFixed(1) + ' L';
    return '₹' + n.toLocaleString('en-IN');
  }

  /* ── RUNWAY CALCULATOR ──────────────────── */
  function calcRunway() {
    var seatsEl  = $('ent-rc-seats');
    var deviceEl = $('ent-rc-device');
    if (!seatsEl || !deviceEl) return;

    var seats  = parseInt(seatsEl.value) || 0;
    var parts  = (deviceEl.value || '22000,55000').split(',');
    var nj     = parseInt(parts[0]) || 22000;
    var newP   = parseInt(parts[1]) || 55000;

    if (seats < 1) return;

    var stg     = STAGE_CONFIG[activeStage] || STAGE_CONFIG.seriesa;
    var volDisc = seats >= 100 ? 0.12 : seats >= 50 ? 0.08 : seats >= 10 ? 0.05 : 0;
    var disc    = Math.max(volDisc, stg.disc);

    var njUnit   = Math.round(nj * (1 - disc));
    var njTotal  = njUnit * seats;
    var newTotal = newP * seats;
    var saving   = newTotal - njTotal;
    var pct      = Math.round((saving / newTotal) * 100);
    var monthly  = Math.round(njUnit * stg.leaseRate * seats);

    var el1 = $('ent-rcr-nj');
    var el2 = $('ent-rcr-new');
    var el3 = $('ent-rcr-save');
    var el4 = $('ent-rcr-lease');
    var el5 = $('ent-rcr-disc');

    if (el1) el1.textContent = fmtINR(njTotal);
    if (el2) el2.textContent = fmtINR(newTotal);
    if (el3) el3.textContent = fmtINR(saving) + ' · ' + pct + '%';
    if (el4) el4.textContent = fmtINR(monthly) + '/mo';

    if (el5) {
     
    }
  }

  /* ── STAGE PILLS ────────────────────────── */
  function initStagePills() {
    $$('.ent-stage-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('.ent-stage-btn').forEach(function (b) { b.classList.remove('ent-on'); });
        btn.classList.add('ent-on');
        activeStage = btn.getAttribute('data-stage') || 'seriesa';
        calcRunway();
      });
    });
  }

  /* ── FAQ ACCORDION ──────────────────────── */
  function initFAQ() {
    $$('.ent-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item   = btn.closest('.ent-faq-item');
        if (!item) return;
        var isOpen = item.classList.contains('open');

        $$('.ent-faq-item.open').forEach(function (i) {
          i.classList.remove('open');
          var q = i.querySelector('.ent-faq-q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── SCROLL REVEAL ──────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.ent-reveal').forEach(function (el) { el.classList.add('ent-vis'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var parent   = entry.target.parentElement;
        var siblings = parent
          ? Array.from(parent.children).filter(function (el) {
              return el.classList.contains('ent-reveal') && !el.classList.contains('ent-vis');
            })
          : [];
        var idx = siblings.indexOf(entry.target);
        setTimeout(function () { entry.target.classList.add('ent-vis'); }, Math.max(0, idx * 80));
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    $$('.ent-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ── GUIDE DOWNLOAD PLACEHOLDER ─────────── */
  function initDownloads() {
    var dlBtn = $('ent-dl-guide');
    if (dlBtn) {
      dlBtn.addEventListener('click', function () {
        alert('Downloading: Startup IT Procurement Guide\n\nContact business@newjaisa.com to receive the full guide.');
      });
    }
  }

  /* ── INIT ───────────────────────────────── */
  function init() {
    initStagePills();

    var seatsEl  = $('ent-rc-seats');
    var deviceEl = $('ent-rc-device');
    if (seatsEl)  seatsEl.addEventListener('input',  calcRunway);
    if (deviceEl) deviceEl.addEventListener('change', calcRunway);
    calcRunway();

    initFAQ();
    initReveal();
    initDownloads();
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  EntPage.init();
});
